export default {
  container: {
    marginBottom: 10
  },
  downloadButtonContainer: {
    display: 'inline-block'
  },
  titleContainer: {
    width: '100%'
  }
};
